import React, {FC, useEffect, useRef} from 'react';
import Style from "./PayrexxModal.module.scss";
import {useDispatch} from "react-redux";
import {SET_LOADER} from "../actions/types";



// Declare the Payrexx plugin module
declare global {
  interface JQuery {
    payrexxModal: (
      options: {
        show: (e: any) => void;
        shown: () => void;
        hide: (transaction: any) => void;
        hidden: (transaction: any) => void;
      }
    ) => JQuery;
  }
}

interface PaymentResponse {
  transactionId: string;
  status: string;
}

interface PaymentError {
  message: string;
  code: string;
}

// Add jQuery to the Window interface
interface PayrexxModalWindow extends Window {
  jQuery: JQueryStatic;
  $: JQueryStatic;
}

interface PayrexxModalProps {
  gatewayUrl: string;
  onSuccess?: (response: PaymentResponse) => void;
  onError?: (error: PaymentError) => void;
  onLoaded?: () => void;
  onOpened?: () => void;
  children?: React.ReactNode;
}

declare const window: PayrexxModalWindow;

const PayrexxModal: FC<PayrexxModalProps> = ({
                                               gatewayUrl,
                                               onSuccess,
                                               onError,
                                               onLoaded,
                                               onOpened,
                                               children = 'Open modal window'
                                             }) => {
  const elementRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    console.log("PayrexxModal initial render")

    if (!elementRef.current) {
      console.warn("No current element in elementRef ")
      return;
    }

    if (typeof window.jQuery === 'undefined') {
      console.error('jQuery is not loaded');
      return;
    }

    // Use jQuery to initialize the modal
    const $element = window.jQuery(elementRef.current);
    $element.payrexxModal({
      show: (e) => {
        console.log("Payrexx show", e);
        dispatch({
          type: SET_LOADER,
          payload: false,
        });
        onLoaded && onLoaded();
      },
      shown: () => {
        console.log("Payrexx shown");
        onOpened && onOpened();
      },
      hide: (transaction) => {
        console.log("Payrexx hide", transaction)
        if (transaction.status === 'confirmed') {
          onSuccess && onSuccess(transaction);
        } else {
          onError && onError({message: 'Payment failed', code: transaction.status});
        }
      },
      hidden: (transaction) => {
        console.log("Payrexx hidden", transaction)
      }
    });

    elementRef.current.click();

  }, []);

  const payrexxDiv = <>
    <div
      ref={elementRef}
      className={Style.payrexxButton}
      data-href={gatewayUrl}
    >
      {children}
    </div>
  </>;
  return payrexxDiv;
};

export default PayrexxModal;
